'use client';

import React, { useMemo } from 'react';
import clx from 'classnames';


import { FilterTag } from '../filterFactory/Filter';
import { useTreatmentFilterStateContext, useTreatmentFilterUpdaterContext } from '../TreatmentFilter/context/TreatmentFilterContext';

import Button from '../../../_ui/_blocks/Buttons/Button/Button';
import Tag from '../../../_ui/_blocks/Tag/Tag';
import Icon from '../../../_ui/_blocks/Icon/Icon';

import styles from './FilterTagCloud.module.css';

interface Props {
    className?: string;
}

const FilterTagCloud = ({ className = '' }: Props) => {
    const { filters } = useTreatmentFilterStateContext();
    const { updateFilters } = useTreatmentFilterUpdaterContext();

    const tags = useMemo(() => {
        const filterValues = Array.from(filters.values());
        const tagsFromFilters = filterValues.map((filter) => filter.tags());
        return tagsFromFilters.reduce((acc: FilterTag[], tags: FilterTag[]) => acc.concat(tags), []);
    }, [filters]);

    const classNames = clx(styles.cloud, className);

    if (!tags.length) {
        return null;
    }

    return (
        <div data-testid="tag-cloud" className={classNames}>
            {tags.map(({ id, label, onClick }) => {
                const handleClick = () => {
                    onClick();
                    updateFilters();
                };

                return (
                    <Button
                        key={id}
                        type="button"
                        variant="none"
                        title={`Remove ${label} from your filters`}
                        onClick={handleClick}
                        className="p-0"
                    >
                        <Tag size="large" color="info" className={styles.tag}>
                            {label}
                            <Icon icon="cross-light" alt="cross icon" size="xxsmall" />
                        </Tag>
                    </Button>
                );
            })}
        </div>
    );
};

export default FilterTagCloud;
